import { module } from 'angular';
import component from './file-viewer.component';
import './file-viewer.scss';

import 'lightbox2';
import 'lightbox2/dist/css/lightbox.min.css';

export default module('app.file-viewer', [])
	.component('fileViewer', component)
	.name;
